import React, { useState, useRef, useEffect } from 'react';
import moment from 'moment';
import axios from 'axios';
import { Editor } from "@tinymce/tinymce-react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField
} from '@material-ui/core';
import './style.scss';
import { SEARCH_PROFILE_API } from "../../apiContants";

const AccountProfileEdit = (props) => {
  const { getSelectedData, edit } = props;
  const useForceUpdate = () => useState()[1];
  const fileInput = useRef(null);
  const forceUpdate = useForceUpdate();
  const [reg, regSet] = useState(Array);
  const [value, setValues] = React.useState({
    subject: "",
    content: "",
  });
  const handleChangeForm = (subject) => (event) => {
    setValues({ ...value, [subject]: event.target.value });
  };

  function onSubmit(e) {
    e.preventDefault();
    const data = new FormData(fileInput.current.files);
  }
  const onSubmited = async () => {
    const data = new FormData();
    data.append("upload_file", fileInput.current.files[0]);
    data.append("title", value.subject);
    data.append("content", reg);
    data.append("id", props.edit.id);
    try {
      const uploadPass = await axios.put(SEARCH_PROFILE_API, data, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    } catch {
      console.log("Error loaidng rejected data");
    }
  };
  function onChange(e) {
    regSet(e.target.getContent());
  }
  function handleChange(content, editor) {
    this.setState({ content });
  }

  return (
    <form autoComplete="off" noValidate {...props}>
      <div className="Notice-content">
        <Grid container spacing={3}>
          <Grid item lg={4} md={6} xs={12}>
            <Card {...props}>
              <CardContent>
                <Box
                  sx={{
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "column",
                    height: 150,
                  }}
                >
                  <div className="App">
                    <form onSubmit={onSubmit}>
                      <input
                        id="file"
                        type="file"
                        ref={fileInput}
                        onChange={forceUpdate}
                        multiple
                      />
                    </form>
                  </div>
                </Box>
              </CardContent>
              <Divider />
            </Card>
          </Grid>
          <Grid item lg={8} md={6} xs={12}>
            <Card>
              <CardHeader
                subheader="The information can be edited"
                title="Notice"
              />
              <Divider />
              <CardContent>
                <TextField
                  fullWidth
                  label="Notice subject"
                  margin="normal"
                  name="password"
                  onChange={handleChangeForm("subject")}
                  value={value.password}
                  defaultValue={props.edit.title}
                  variant="outlined"
                />
                <Editor
                  initialValue={props.edit.content}
                  init={{
                    plugins: "link image code",
                    toolbar:
                      "undo redo | bold italic | alignleft aligncenter alignright | code",
                  }}
                  onChange={onChange}
                />
              </CardContent>
              <Divider />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  p: 2,
                }}
              >
                <Button
                  href="/app/event"
                  className="cancel_button"
                  color="primary"
                  variant="contained"
                >
                  Cancel
                </Button>
                <Button
                  onClick={() => onSubmited()}
                  color="primary"
                  variant="contained"
                >
                  Save details
                </Button>
              </Box>
            </Card>
          </Grid>
        </Grid>
      </div>
    </form>
  );
};

export default AccountProfileEdit;
